/**
 * @generated SignedSource<<7c6cbd58495b5dd2c9cc9567efff6911>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionSidebarFilesList_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LibraryFile",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LibraryFile_file"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSidebarSectionTitle_pageSection"
    }
  ],
  "type": "PageSectionFilesList",
  "abstractKey": null
};

node.hash = "3f5a170b842d8d72a319a50ba8ba5f52";

module.exports = node;
